import { Pipe, PipeTransform } from '@angular/core';
import {KeyValue} from '@angular/common';

@Pipe({
  name: 'truckSelection'
})
export class TruckSelection implements PipeTransform {

  transform(value: Array<KeyValue<string, any>>, ...args: any[]): Array<KeyValue<string, any>> {
    return value.filter(({value: val}) => val);
  }

}
